import ArrowDownIcon from './ArrowDownIcon';
import styles from './styles.module.scss';

function InquiryNavigator() {
  const handleScroll = (direction: 'top' | 'bottom') => {
    const contents = document.querySelector<HTMLDivElement>('#cta-contents')!;
    if (direction === 'top') {
      contents.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      const { scrollHeight } = contents;
      contents.scrollTo({ top: scrollHeight, behavior: 'smooth' });
    }
  };
  return (
        <div className={styles.container}>
            <ArrowDownIcon className={styles.icon}
                           onClick={() => handleScroll('top')} />
            <ArrowDownIcon className={styles.icon}
                           onClick={() => handleScroll('bottom')} />
        </div>
  );
}

export default InquiryNavigator;
